export default __webpack_public_path__ + "static/media/calender.7545d1ef.svg";